import React from "react";
import { NavLink, useHistory } from "react-router-dom";

import "./SubRouteMenu.style.scss";
import { P_Props } from "./SubRouteMenu.type";
import clsx from "clsx";

const SubRouteMenuPresenter: React.FC<P_Props> = (props) => {
  const history = useHistory();

  const isActiveRoute = (pathname: string): boolean => {
    return history.location.pathname.includes(pathname);
  };

  return (
    <div className="sub-route-menu">
      {props.routeMenu.map((item, idx) => {
        const isActive = isActiveRoute(item.path);
        const classes = clsx({
          "sub-route-menu__item": true,
          active: isActive,
        });

        const cloneItem: any = item;
        return (
          <NavLink key={item.path + idx} exact={true} to={item.path} className={classes}>
            {cloneItem?.images && (
              <img
                className="sub-route-menu__item--image"
                src={isActive ? cloneItem.images.active : cloneItem.images.inactive}
                alt="icon_menu"
              />
            )}
            {cloneItem?.icons && (
              <div className="sub-route-menu__item--icon">
                {isActive ? cloneItem.icons.active : cloneItem.icons.inactive}
              </div>
            )}
            <span className="sub-route-menu__item--title">{item.title}</span>
          </NavLink>
        );
      })}
    </div>
  );
};

export default SubRouteMenuPresenter;
